import type { UseQueryOptions } from '@tanstack/react-query';

import { settingsGetForcePointTotals } from '@crossnokaye/typescript-sdk/funcs/settingsGetForcePointTotals';
import { ForcePointTotals } from '@crossnokaye/typescript-sdk/models/components';
import { SDKError } from '@crossnokaye/typescript-sdk/models/errors';
import {
  GetForcePointTotalsRequest,
  GetForcePointTotalsResponse,
} from '@crossnokaye/typescript-sdk/models/operations';

import { AtlasClientFunction } from '@/client/types';
import { AtlasQueryWithOrgIdAndAgentId } from '@/queries/types';

const transformGetForcePointTotalsResponse = (
  response: GetForcePointTotalsResponse
): ForcePointTotals | undefined => {
  return response.forcePointTotals;
};

export interface GetForcePointTotalsQueryProps extends AtlasQueryWithOrgIdAndAgentId {
  transform?: (response: GetForcePointTotalsResponse) => ForcePointTotals | undefined;
  client: AtlasClientFunction;
}

export const getForcePointTotalsQuery = ({
  orgId,
  agentId,
  transform = transformGetForcePointTotalsResponse,
  client,
}: GetForcePointTotalsQueryProps): UseQueryOptions<
  GetForcePointTotalsResponse,
  SDKError,
  ForcePointTotals | undefined
> => {
  return {
    enabled: !!orgId && !!agentId,
    queryKey: [orgId, agentId, 'getForcePointTotals'],
    queryFn: () =>
      client<GetForcePointTotalsRequest, GetForcePointTotalsResponse>({
        atlasFunc: settingsGetForcePointTotals,
        request: { orgId: orgId!, agentId: agentId! },
      }),
    select: transform,
  };
};
